export default {
  methods: {
    // fetching branches
    async fetchAllBranches(hospital = "") {
      let branchParams = { get_all: true };
      if(hospital) {
        branchParams.hospital_id = hospital;
      }
      await this.$store.dispatch("branches/fetchAllBranches", branchParams);
    },
    // fetching physicians
    async fetchAllPhysicians(data = {}) {
      let params = { get_all: true};
      if (data.hospitalBranch) {
        params.hospital_branch = data.hospitalBranch;
      }
      if (data.hospital) {
        params.hospital = data.hospital;
      }
      
      await this.$store.dispatch("physicians/fetchAllPhysicians", params);
    },
  }
}